import React from 'react'
import fallBackImg from 'assets/images/svg/image_placeholder.svg'

const PreviewImage = ({ src, alt = 'default-server-img', ...props }) => {
    const [imageSrc, setImageSrc] = React.useState(src)
    
    return (
        <img src={imageSrc ? src : fallBackImg} alt={alt}  onError={() => setImageSrc(null)} height={props.width} {...props} />
    )
}

export default PreviewImage
